<template>
    <div class="util-min-h40">
        <div class="flex-container" v-if="!processing">
            <Select
                :disabled="playbooks.length < 1"
                v-model="selected"
                placeholder="Select a playbook to trigger manually."
                :clearable="true"
                ref="selectPlaybooks"
            >
                <Option
                    v-for="playbook in playbooks"
                    :key="playbook.id"
                    :label="playbook.name"
                    :value="playbook.id"
                ></Option>
            </Select>
            <Button
                class="ml-3"
                :disabled="!selected"
                type="primary"
                @click="handleConfirm"
                >Trigger Playbook</Button
            >
        </div>
        <loading-component v-else> </loading-component>
    </div>
</template>

<script>
export default {
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
        playbooks: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            selected: null,
        };
    },
    methods: {
        handleConfirm() {
            this.$emit("playbook:trigger", this.selected);
            this.$refs["selectPlaybooks"].clearSingleSelect();
        },
    },
};
</script>
